'use client'

import {
  CartSummaryPricingDocument,
  MiniCartButtonDocument,
  MiniCartDocument,
} from '.generated/types'
import { useApolloClient } from '@apollo/client'
import { useCallback, useEffect, useRef } from 'react'

type UseRefetchMiniCartButtonOptions = {
  callOnMount?: boolean
}

export const useRefetchMiniCartButton = (options: UseRefetchMiniCartButtonOptions = {}) => {
  const { callOnMount = true } = options
  const client = useApolloClient()

  const refetchMiniCartButton = useCallback(() => {
    client.refetchQueries({
      include: [MiniCartButtonDocument, MiniCartDocument, CartSummaryPricingDocument],
    })
  }, [client])

  const isMountedRef = useRef(false)

  useEffect(() => {
    if (isMountedRef.current !== true && callOnMount) {
      isMountedRef.current = true
      refetchMiniCartButton()
    }
  }, [callOnMount, refetchMiniCartButton])

  return refetchMiniCartButton
}
